import React from 'react'
import moment from "moment";
import Day from "./Day";
function Week({currentWeek, weekCount,updateCalendarDates,activeWeek,
    dateRange, currMonth,calendarDates}) {
    const days=[];
    days.push({
        display:weekCount, type:"weekNumber", 
        activeWeek:activeWeek,
        date:moment(currentWeek).format("YYYY-MM-DD")
    })
    for (let index = 0; index < 7; index++) {
        let date = moment(currentWeek).add(index, 'days').format("YYYY-MM-DD");
        days.push({
            display:moment(date).format("DD"),type:"date", date
        })
        
    }

    return (
        <div className="calendar-week">
            {
                days.map(day=>{
                    return(<Day display={day.display} date={day.date} dateRange={dateRange}
                        updateCalendarDates={updateCalendarDates}  currMonth={currMonth}
                         calendarDates={calendarDates} day={day}
                        type={day.type}
                    />)
                })
            }
        </div>
    )
}

export default Week
